import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PublicidadPopupData {
  image: string;
  alt: string;
}

@Component({
  selector: 'app-publicidad-popup-dialog',
  templateUrl: './publicidad-popup-dialog.component.html',
  styleUrls: ['./publicidad-popup-dialog.component.css']
})
export class PublicidadPopupDialogComponent {

  constructor(
    private _dialogRef: MatDialogRef<PublicidadPopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PublicidadPopupData
  ) {}

  cerrar(): void {
    this._dialogRef.close();
  }
}
